import axios from 'axios';

const ENDPOINT = 'report';

export default {

  printQUnit: async (centro, pk, template) => {
    const epk = encodeURIComponent(pk);
    const url = `${centro}/${ENDPOINT}/${epk}/get_qunit_report/?template=${template}`;
    const response = await axios.get(url, {responseType: 'arraybuffer'});
    return response;
  },

  printList: async (centro, template, bp, filters) => {
    const url = `${centro}/${ENDPOINT}/get_list_report/`;
    let encoded_filters = {};
    for (const [key, value] of Object.entries(filters)){
      encoded_filters[key] = encodeURIComponent(value);}
    encoded_filters['business_process'] = encodeURIComponent(bp);
    const response = await axios.get(url, {
      responseType: 'arraybuffer',
      params: {
        template: template,
        ...encoded_filters,
      },
    });
    return response;
  },

  listListTemplates: async (centro, bp) => {
    const url = `${centro}/${ENDPOINT}/get_list_templates/`;
    const response = await axios.get(url, {params: {bp: bp}});
    return response;
  },

  pdfQUnit: async (centro, pk, template) => {
    const epk = encodeURIComponent(pk);
    const url = `${centro}/${ENDPOINT}/${epk}/get_qunit_pdf/?template=${template}`;
    const response = await axios.get(url, {responseType: 'arraybuffer'});
    return response;
      
  },

  printQUnitCustomTemplate: async (centro, pk, template_file) => {
    const epk = encodeURIComponent(pk);
    let formData = new FormData();
    formData.append("template", template_file);

    const url = `${centro}/${ENDPOINT}/${epk}/get_qunit_custom_report/`;
    // const response = await axios.get(url, { responseType: 'arraybuffer' })
    const response = await axios({
      method: 'post',
      url: url,
      data: formData,
      config: {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
      responseType: 'arraybuffer'
    });
    
    return response;
  },

  printListCustomTemplate: async(centro, filters, template_file) => {
    let formData = new FormData();
    formData.append("template", template_file);
    const url = `${centro}/${ENDPOINT}/get_list_custom_report/`;
    const response = await axios({
      method: 'post',
      url: url,
      data: formData,
      responseType: 'arraybuffer',
      params: filters.as_query()
    });
    return response;
  },
}
